var React = require('react');

function FreezoneSectionArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M197.073 237.115C171.457 211.5 44 84 -40 0L-40 16L178 237L-40 462L-40 474L197.073 237.115Z","fill":"#CE435B","key":0}),React.createElement("path",{"d":"M185.073 237.115C159.457 211.5 44 100 -40 16V38L162 237L-40 436L-40 462L185.073 237.115Z","fill":"#CE435B","key":1})]);
}

FreezoneSectionArrow.defaultProps = {"viewBox":"0 0 197 474","fill":"none"};

module.exports = FreezoneSectionArrow;

FreezoneSectionArrow.default = FreezoneSectionArrow;
